var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"value":_vm.page,"length":Math.ceil(_vm.count/10),"color":"#2222BF"},on:{"input":_vm.getPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }